import { createSelector } from "reselect"
import _toString from "lodash/toString"
import { State } from "store"
import { Segment } from "resources/segment/segment/segmentTypes"

const getSegmentsAcls = (state: State, id: Segment["id"]) =>
  state.acls.getIn(["data", _toString(id)])

export const getSegmentsAclsList = createSelector([getSegmentsAcls], acls => acls)
